import { computed } from '@nuxtjs/composition-api';
import { sharedRef, useVSFContext } from '@vue-storefront/core';
import { useApiError } from '../useApiError';
export const useGuest = (): any => {
  // Loads context used to call API endpoint
  const context = useVSFContext();
  const { set: setError } = useApiError();
  // Shared ref holding the response from the API
  const guest = sharedRef(null, 'useGuest');

  // Shared ref indicating whether any method is waiting for the data from the API
  const loading = sharedRef(false, 'useGuest-loading');
  const token = sharedRef(null, 'useGuest-token');
  // Shared ref holding errors from the methods
  const error = sharedRef({
    token: null
  }, 'useGuest-error');

  // Method to call an API endpoint and update `result`, `loading` and `error` properties
  const login = async (params) => {
    try {
      loading.value = true;
      // Change "yourIntegration" to the name of the integration
      const res = await context.$xbuy.api.guestLogin(params);
      if (res && res.token) {
        guest.value = res;
        context?.$cookies?.set("token", guest.value?.token, {
          path: "/",
          sameSite: "Lax",
          maxAge: 3600 * 24 * 365
        });
        error.value = null;
      } else {
        error.value = res.message;
      }
    } catch (err) {
      error.value = err;
    } finally {
      loading.value = false;
    }
  };
  const setToken = async (params) => {
    try {
      // Change "yourIntegration" to the name of the integration
      const res = await context.$xbuy.api.setToken(params);
      if (res.code > 0) {
        res.time = 60000000;
        setError(res);
      }
    } catch (err) {
      error.value = err;
    } finally {
      loading.value = false;
    }
  }
  const getToken = async (params) => {
    try {
      // Change "yourIntegration" to the name of the integration
      const res = await context.$xbuy.api.guestGetToken(params);
      if (res && res.token) {
        guest.value = res;
        context?.$cookies?.set("token", guest.value?.token, {
          path: "/",
          sameSite: "Lax",
          maxAge: 3600 * 24 * 365
        });
        error.value = null;
      } else {
        error.value = res.message;
        setError(res);
      }
    } catch (err) {
      error.value = err;
    } finally {
      loading.value = false;
    }
  }
  return {
    getToken,
    login,
    setToken,
    guestToken: computed(() => token.value),
    guest: computed(() => guest.value),
    loading: computed(() => loading.value),
    error: computed(() => error.value)
  };
};
